import React from 'react';
import styled from '@emotion/styled';

type Props = {
  children: any;
};

function List({ children }: Props) {
  return <Container>{children}</Container>;
}

export default List;

const Container = styled('ol')`
  list-style: none;
  width: 100%;

  li {
    display: grid;
    grid-template-columns: 1fr auto;
    grid-gap: 16px;
    border-bottom: 1px solid #eee;
    min-height: 48px;
    padding: 0 16px;
    align-items: center;
    color: #666;
  }
`;
